var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.domainName && !_vm.isDomainOwnershipVerified)?_c('div',{staticClass:"domain-change-option"},[_c('span',{domProps:{"innerHTML":_vm._s(
      _vm.$t('domainActivation.protectDomain.desc.line2.1', {
        domain: _vm.domainName,
      })
    )}}),_c('change-domain-link',{attrs:{"sourceHook":_vm.sourceHook}})],1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }